import React from 'react';
import { Box } from '@osmosis/tailwind-ui/components/Box';
import { BoxProps } from '@osmosis/tailwind-ui/components/Box';

/**
 * Message.
 */
const Message = (props: BoxProps) => {
  return <Box {...props} cn={`px-3 py-2 rounded-[10px] ${props.cn || ''}`} />;
};

export default Message;
